import React from 'react';
import { useNavigate } from 'react-router-dom';
import { List, Plus } from 'lucide-react';
import { OpportunityKanban } from '../components/OpportunityKanban';

/**
 * Página `/oportunidades/kanban` — visão em funil por etapa (spec
 * §Filtros e Visões, task 14.2).
 *
 * Fatia 12 é a versão inicial:
 *   - Sem virtualização (mostra até 100 cards por coluna com aviso de
 *     overflow)
 *   - Sem seleção de filtros compartilhados com a Lista (spec pede
 *     hook `useOportunidadeFilters`) — o hook compartilhado vem numa
 *     fatia dedicada
 */
export default function OportunidadesKanbanPage(): React.ReactElement {
  const navigate = useNavigate();

  return (
    <div className="p-6 space-y-6">
      <div className="mb-4 flex flex-col justify-between gap-4 md:flex-row md:items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">
            Pipeline — visão Kanban
          </h1>
          <p className="mt-1 text-sm text-gray-600">
            <span className="hidden md:inline">
              Arraste os cards entre as colunas para movimentar a etapa. Retrocessos
              exigem justificativa (mínimo 20 caracteres).
            </span>
            <span className="md:hidden">
              Deslize para o lado para trocar de etapa. Toque e segure um card
              para arrastá-lo entre colunas.
            </span>
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => navigate('/oportunidades')}
            className="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
          >
            <List className="h-4 w-4" />
            Visão Lista
          </button>
          <button
            onClick={() => navigate('/oportunidades/nova')}
            className="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 transition-colors"
          >
            <Plus className="h-4 w-4" />
            Nova oportunidade
          </button>
        </div>
      </div>

      <OpportunityKanban />
    </div>
  );
}
